/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-08 10:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';


type Props = {
  active: boolean,
  handleChange: () => void,
  handleApprove: () => void,
  updatePermissionLink: string
};

type ComposedProps = Props & WithI18nProps;
class ConfirmRemoveModal extends Component<ComposedProps> {
  render() {
    const { active, enableOrderRevenue, i18n } = this.props;

    return (
      <Modal
        open={active}
        large
        onClose={this.handleChange}
        title={
          enableOrderRevenue
            ? i18n.translate(
                'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_ModalTitle_TurnOff'
              )
            : i18n.translate(
                'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_ModalTitle_TurnOn'
              )
        }
        primaryAction={{
          content: enableOrderRevenue
            ? i18n.translate(
                'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_ModalPrimaryActionContent_TurnItOff'
              )
            : i18n.translate('AdminHTML.Common.Action.continue'),
          onAction: this.handleContinue,
          destructive: enableOrderRevenue ? true : false
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleChange
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            {enableOrderRevenue ? (
              <p>
                {i18n.translate(
                  'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_EnableOrderRevenue_Content1',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_EnableOrderRevenue_Content1_t1'
                        )}
                      </TextStyle>
                    ),
                    t2: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_EnableOrderRevenue_Content1_t2'
                        )}
                      </TextStyle>
                    ),
                    t3: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_EnableOrderRevenue_Content1_t3'
                        )}
                      </TextStyle>
                    )
                  }
                )}
                <br />
                {i18n.translate(
                  'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_EnableOrderRevenue_Content2'
                )}
              </p>
            ) : (
              <p>
                {i18n.translate(
                  'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_NoEnableOrderRevenue_Content',
                  {
                    t: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Analytics.Settings.confirmToggleOrderRevenueModal_TextContainer_NoEnableOrderRevenue_Content_t'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </p>
            )}
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };

  handleContinue = () => {
    const { updatePermissionLink, handleApprove } = this.props;
    // `enableOrderRevenue` indicates current enable state => being toggled to next state

    // Tracking event on active campaign
    handleApprove();

    // Setup redirect URI
    try {
      localStorage.setItem(`${getShop()}-permissionApproval-redirectURI`, '/analytics');
    } catch (error) {}

    window.top.location.href = updatePermissionLink;
  };
}

export default withI18n()(ConfirmRemoveModal);
